import { defineMessages } from 'react-intl';

export default defineMessages({
	planPreviewTagline: {
		id: 'teams.planPreview.tagline',
		defaultMessage: 'Teams Plan',
		description: 'Plan type tagline text shown above heading for the plan preview.',
	},
	planPreviewTaglineWithUsers: {
		id: 'teams.planPreview.taglineWithUsers',
		defaultMessage: 'Teams Plan ({coveredLivesCount} Users)',
		description:
			'Plan type tagline text shown above heading for the plan preview with the number of covered lives they selected.',
	},
	planPreviewHeading: {
		id: 'teams.planPreview.heading',
		defaultMessage: '5-{maxCoveredLives} People',
		description: 'Navigation option used in the Teams page navigation',
	},
	planPreviewPricePerYear: {
		id: 'teams.planPreview.pricePerYear',
		defaultMessage: '{annualPrice}/year',
		description: 'Total yearly cost(or savings) of their selected plan.',
	},
	planPreviewCopy: {
		id: 'teams.planPreview.copy',
		defaultMessage: 'Calm For Organizations: {annualPrice} / year for {coveredLivesCount} individuals',
		description: 'Plan type copy that displays annual cost and the number of covered lives. ',
	},
	planPreviewTaglineMobile: {
		id: 'teams.planPreview.headingMobile',
		defaultMessage: 'Calm For Organizations',
		description: 'Plan type tagline text shown above heading for the plan preview.',
	},
	planPreviewCopyMobile: {
		id: 'teams.planPreview.copyMobile',
		defaultMessage: '{annualPrice} / year for {coveredLivesCount} individuals',
		description: 'Plan type copy that displays annual cost and the number of covered lives. ',
	},
	editCoveredLivesLink: {
		id: 'teams.planPreview.edit',
		defaultMessage: 'Edit',
		description: 'Edit the number of covered lives.',
	},
});
